import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { MapPin, AlertCircle } from 'lucide-react';

const ServiceAreaPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-black text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <MapPin className="w-16 h-16 text-red-600 mx-auto mb-4" />
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Our <span className="text-red-600">Service Area</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Proudly serving Lexington, KY and surrounding communities
            </p>
          </div>
        </div>
      </section>

      {/* Map and Info */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
            {/* Map */}
            <Card>
              <CardContent className="p-6">
                <h2 className="text-2xl font-bold mb-4">100-Mile Service Radius</h2>
                <div className="relative w-full h-96 bg-gray-200 rounded-lg overflow-hidden">
                  <iframe
                    title="Service Area Map"
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    style={{ border: 0 }}
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d793524.4774567892!2d-85.23598937304688!3d38.04897805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88424429cc9ceb25%3A0x84f08341908c4435!2sLexington%2C%20KY!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
                    allowFullScreen
                  />
                </div>
                <p className="text-sm text-gray-600 mt-4">
                  Our service area extends 100 miles from Lexington, KY in all directions
                </p>
              </CardContent>
            </Card>

            {/* Service Areas List */}
            <div className="space-y-6">
              <Card>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold mb-4">Primary Service Areas</h3>
                  <div className="grid grid-cols-2 gap-3">
                    {[
                      'Lexington',
                      'Georgetown',
                      'Nicholasville',
                      'Winchester',
                      'Richmond',
                      'Frankfort',
                      'Versailles',
                      'Paris',
                      'Mount Sterling',
                      'Danville',
                      'Lancaster',
                      'Harrodsburg'
                    ].map((city, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <MapPin className="w-4 h-4 text-red-600 flex-shrink-0" />
                        <span className="text-gray-700">{city}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-blue-50 border-blue-200">
                <CardContent className="p-6">
                  <div className="flex items-start gap-3">
                    <AlertCircle className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-blue-900 mb-2">Extended Service Areas</h3>
                      <p className="text-blue-800 text-sm">
                        We serve locations within 100 miles of Lexington, KY. For locations beyond 100 miles, 
                        additional travel fees may apply. Contact us to confirm availability and pricing for your specific location.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold mb-4">Not Sure If We Serve Your Area?</h3>
                  <p className="text-gray-700 mb-4">
                    Contact us to confirm service availability in your location. We're always looking to expand 
                    our service area to reach more customers!
                  </p>
                  <div className="flex flex-col sm:flex-row gap-3">
                    <a 
                      href="/contact" 
                      className="inline-flex items-center justify-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors"
                    >
                      Contact Us
                    </a>
                    <a 
                      href="mailto:tpcslex@gmail.com" 
                      className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-300 hover:border-red-600 hover:text-red-600 font-medium rounded-md transition-colors"
                    >
                      Email Us
                    </a>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceAreaPage;
